import { KeyboardEventHandler, useEffect, useState } from "react";
import { CheckedInput, Container, DropdownIcon, ExtraOfferPrice, ExtraPrice, InfoItem, InfoList, Input, OfferContainer, OfferContainerDark, OfferLabel, OfferText, Price, PriceContainer, PriceDefinition, ProductCard, ProductCardContainer, Teaser, Title, TitleContainer, TopContainer, TopContainerLeft, TopContainerRight } from "./ProductCard.style";
import { BiCheck } from "react-icons/bi";
import { useStore } from "../../../../store/store";


interface Props {
    id: string;
    title: string | undefined;
    price: string | undefined | JSX.Element;
    extraPrice?: string;
    extraOfferPrice?: string;
    offerText?: string;
    bottomOfferText?: string;
    hasOffer?: boolean;
    info?: Array<any>;
    removekrPerMonth?: boolean;
    onClick?: () => void;
    isChecked: boolean;
    onKeyDown: KeyboardEventHandler<HTMLDivElement>;
}

export default function ProductCardV2({title, price, extraPrice, offerText, extraOfferPrice, bottomOfferText, hasOffer, info, onClick, isChecked = false, onKeyDown, removekrPerMonth, id}: Props) {
 const [showInfo, setShow] = useState(false);
 const [dropdownClickedNumber, setDropdownClickedNumber] = useState(0);
 const setDropdownProductcardClicked = useStore.useSetDropdownProductcardClicked();

const handleDropdownClick = () => {
    showInfo ? setShow(false) : setShow(true);
}

const setDropdownClicked = (id: string) => { 
    const clicked = dropdownClickedNumber + 1;
    const clickedString = `${id}Clicked${clicked}`;
    setDropdownClickedNumber(clicked);
    setDropdownProductcardClicked(clickedString);
}

  return (
      <Container>
          <ProductCardContainer isChecked={isChecked}>
          {hasOffer && offerText && offerText != "" && (
              <OfferContainer>
                <OfferText>{offerText}</OfferText>
                <OfferLabel>Tilbud</OfferLabel>    
            </OfferContainer>
          )}
              <ProductCard onClick={onClick} isChecked={isChecked} tabIndex={0} onKeyDown={onKeyDown} hasOffer={hasOffer} hasBottomOffer={isChecked && bottomOfferText ? true : false}>
                  <TopContainer>
                      <TopContainerLeft>
                        <Input isChecked={isChecked}>
                            {isChecked && (<CheckedInput/>)} 
                        </Input>
                        <TitleContainer>
                          <Title>{title}</Title>
                        </TitleContainer>
                      </TopContainerLeft>
                      <TopContainerRight onClick={(e) => {e.stopPropagation(); handleDropdownClick(); setDropdownClicked(id);}}>
                        <DropdownIcon src="../assets/images/dropdown-blue.svg" isOpen={showInfo}/>
                      </TopContainerRight>
                  </TopContainer>
                  <PriceContainer>
                      <Price>
                          {price} {!removekrPerMonth && (<PriceDefinition> kr./md.</PriceDefinition>)}
                      </Price>
                        {extraOfferPrice && (
                        <ExtraOfferPrice>
                            {extraOfferPrice}
                        </ExtraOfferPrice>
                        )}
                      {extraPrice && 
                      <ExtraPrice>
                          {extraPrice}
                      </ExtraPrice>
                      }
                  </PriceContainer>
                  <InfoList show={showInfo}>
                      {info?.map((item) => {       
                          return (<InfoItem key={item.description}>{item.description}</InfoItem>) 
                      })}
                  </InfoList>
              </ProductCard>
         {/*  {isChecked && bottomOfferText && (
              <OfferContainerDark>
                  {bottomOfferText}
              </OfferContainerDark>
          )} */}
          </ProductCardContainer>
      </Container>
  )
}